import { render, staticRenderFns } from "./Advertisements.vue?vue&type=template&id=27f088b4&scoped=true&"
import script from "./Advertisements.vue?vue&type=script&lang=js&"
export * from "./Advertisements.vue?vue&type=script&lang=js&"
import style0 from "./Advertisements.vue?vue&type=style&index=0&id=27f088b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f088b4",
  null
  
)

export default component.exports